import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './PageLayout.css';

interface PageLayoutProps {
  children: React.ReactNode;
  title: string;
}

const PageLayout: React.FC<PageLayoutProps> = ({ children, title }) => {
  const { user, signOut } = useAuth();
  const location = useLocation();

  const handleSignOut = async () => {
    try {
      await signOut();
    } catch (error) {
      console.error('Failed to sign out:', error);
    }
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <div className="page-layout">
      <nav className="page-nav">
        <div className="nav-brand">
          <h1>StageSpotter Admin</h1>
        </div>
        <div className="nav-user">
          <span>{user?.signInDetails?.loginId || 'Admin'}</span>
          <button onClick={handleSignOut}>Sign Out</button>
        </div>
      </nav>
      <div className="page-content">
        <aside className="page-sidebar">
          <nav className="sidebar-nav">
            <Link to="/" className={`nav-link ${isActive('/') ? 'active' : ''}`}>
              Dashboard
            </Link>
            <Link to="/venues" className={`nav-link ${isActive('/venues') ? 'active' : ''}`}>
              Venues
            </Link>
            <Link to="/venues/allowlist" className={`nav-link ${isActive('/venues/allowlist') ? 'active' : ''}`}>
              Venue Allowlist
            </Link>
            <Link to="/venues/groups" className={`nav-link ${isActive('/venues/groups') ? 'active' : ''}`}>
              Venue Grouping
            </Link>
            <Link to="/events" className={`nav-link ${isActive('/events') ? 'active' : ''}`}>
              Events
            </Link>
            <Link to="/artists" className={`nav-link ${isActive('/artists') ? 'active' : ''}`}>
              Artists
            </Link>
            <Link to="/ingestion" className={`nav-link ${isActive('/ingestion') ? 'active' : ''}`}>
              Ingestion
            </Link>
            <Link to="/regions" className={`nav-link ${isActive('/regions') ? 'active' : ''}`}>
              Regions
            </Link>
            <Link to="/usage" className={`nav-link ${isActive('/usage') ? 'active' : ''}`}>
              API Usage
            </Link>
            <Link to="/subscriptions" className={`nav-link ${isActive('/subscriptions') ? 'active' : ''}`}>
              Email Subscriptions
            </Link>
            <Link to="/cdn" className={`nav-link ${isActive('/cdn') ? 'active' : ''}`}>
              CDN Management
            </Link>
            <Link to="/share-activity" className={`nav-link ${isActive('/share-activity') ? 'active' : ''}`}>
              Share Activity
            </Link>
            <Link to="/admin/venue-views" className={`nav-link ${isActive('/admin/venue-views') ? 'active' : ''}`}>
              Venue Views
            </Link>
            <Link
              to="/admin/calendar-views"
              className={`nav-link ${isActive('/admin/calendar-views') ? 'active' : ''}`}
            >
              Calendar Views
            </Link>
            <Link to="/admin/ticket-clicks" className={`nav-link ${isActive('/admin/ticket-clicks') ? 'active' : ''}`}>
              Ticket Clicks
            </Link>
            <Link to="/api-explorer" className={`nav-link ${isActive('/api-explorer') ? 'active' : ''}`}>
              API Explorer
            </Link>
          </nav>
        </aside>
        <main className="page-main">
          <h2 className="page-title">{title}</h2>
          {children}
        </main>
      </div>
    </div>
  );
};

export default PageLayout;

